enum INTERVAL {
    monthly = "Mensal",
    weekly = "Semanal",
    daily = "Diário",
    annually = "Anual",
    Mensal = "Mensal",
}

export function translateFrequencyOrInterval (interval: string) {
    return INTERVAL[interval as keyof typeof INTERVAL] ?? null;
}